/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { SimpliCityFormattedImage } from "cms/image/formatted-image";
import { useSimWebpageImage } from "cms/hooks/use-sim-webpage-image";

/**
 * WebpageImage
 * For use to get banner images for webpages directly
 * @param props
 * @returns {Element}
 * @constructor
 */
const WebpageImage = (props) => {

    const webpage_guid = props?.webpage_guid;
    const { image, settings } = useSimWebpageImage(webpage_guid);
    const showCaption = settings?.options?.useCaption ?? false;

    return (
        <>
            {image && (
                <Fragment>
                    <SimpliCityFormattedImage
                        image={image}
                        settings={settings}
                        showCaption={showCaption}
                    />
                </Fragment>
            )}
        </>
    );
};

export { WebpageImage };
